module.exports = __webpack_public_path__ + "static/media/right-arrow-circle-grey.190bef19.svg";